<div class="final-report-container" data-cy="finalreport-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="finalreport-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="finalreport-header">
      <div class="section-header-title" data-cy="finalreport-title">
        Final Report
      </div>
      <div style="flex: 1;"></div>
    </div>
    <app-tdo-progress-spinner class="spinner" style="flex: 1;" *ngIf="isLoading" data-cy="finalreport-spinner"></app-tdo-progress-spinner>
    <!--  MAIN AREA-->
    <div class="section-content ui-dark-background"
         style="padding: 2px; flex: 1; margin-top: 6px; background-color: var(--tdo-background); overflow: hidden;" data-cy="finalreport-content">
      <div *ngIf="!isLoading" style="display: flex; max-height: 100%; overflow-y: hidden;" data-cy="finalreport-main">
        <div
          style="margin-right: 3px; flex-basis: 50%; border-radius: var(--border-radius); display: flex; flex-direction: column; height: fit-content;" data-cy="finalreport-left-panel">
          <div class="final-report-left-cell" style="flex-basis: fit-content;" data-cy="finalreport-info-section">
            <div style="flex: 2; overflow: hidden;">
              <div class="final-report-top-left-row" data-cy="finalreport-case-row">
                <div class="final-report-top-left-row-label" data-cy="finalreport-case-label">Case:</div>
                <div class="final-report-input-container" style="flex: 1;" data-cy="finalreport-case-input">
                  <input [readonly]="true" [ngModel]="patientCaseModel.Description" data-cy="finalreport-case-value"/>
                </div>
              </div>
              <div class="final-report-top-left-row" data-cy="finalreport-tooth-row">
                <div class="final-report-top-left-row-label" data-cy="finalreport-tooth-label">Tooth:</div>
                <div class="final-report-input-container" style="flex: 1;" data-cy="finalreport-tooth-input">
                  <input [readonly]="true" [ngModel]="toothName" data-cy="finalreport-tooth-value"/>
                </div>
              </div>
              <div class="final-report-top-left-row" data-cy="finalreport-status-row">
                <div class="final-report-top-left-row-label" data-cy="finalreport-status-label">Case Status:</div>
                <div class="final-report-dropdown" style="flex: 1; height: 26px;" data-cy="finalreport-status-select">
                  <app-tdo-enum-select name="enumFinalReportCaseStatus"
                                       [validValueItemId]="finalReportModel.enumFinalReportCaseStatusID"
                                       (enumSelected)="onCaseStatusChange($event)"
                                       (isUserInput)="setUserInput($event)"
                                       displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                </div>
              </div>
              <div class="final-report-top-left-row" data-cy="finalreport-prognosis-row">
                <div class="final-report-top-left-row-label" data-cy="finalreport-prognosis-label">Prognosis:</div>
                <div style="flex: 1;" class="final-report-dropdown" data-cy="finalreport-prognosis-select">
                  <app-tdo-enum-select name="enumFinalReportPrognosis"
                                       [validValueItemId]="finalReportModel.enumFinalReportPrognosisID"
                                       (enumSelected)="FinalReportPrognosisSelected($event);"
                                       (isUserInput)="setUserInput($event)"
                                       displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                </div>
              </div>
              <div class="final-report-top-left-row" data-cy="finalreport-recall-row">
                <div class="final-report-top-left-row-label" data-cy="finalreport-recall-label">Recall:</div>
                <div style="flex: 1;" class="final-report-dropdown" data-cy="finalreport-recall-select">
                  <app-tdo-enum-select name="enumFinalReportRecall"
                                       [validValueItemId]="finalReportModel.enumFinalReportRecallID"
                                       (enumSelected)="onRecallTimeChange($event)"
                                       (isUserInput)="setUserInput($event)"
                                       displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                </div>
                <div style="flex-basis: 4px;"></div>
                <div style="flex: 1; max-width: 130px;" data-cy="finalreport-recall-date"><input [value]="getDateFromModel(finalReportModel.RecallDate)"
                                                               style="border: unset; outline: unset; background-color: var(--tdo-background); border-radius: var(--border-radius);">
                </div>
              </div>
              <div class="final-report-top-left-row" data-cy="finalreport-referto-row">
                <div class="final-report-top-left-row-label" data-cy="finalreport-referto-label">Refer To:</div>
                <div style="flex: 1;" class="final-report-dropdown" data-cy="finalreport-referto-select">
                  <tdo-dropdown-v2 [datasource]="nonGpDoctors"
                                   [value]="getDoctor(gpDoctors, finalReportModel.RefereToDoctorID)"
                                   [displayPredicate]="doctorDisplayPredicate"
                                   (selectionChange)="$event.value ? referrToDoctorSelected($event) : log('undefined referrToDoctorSelected value', $event)"></tdo-dropdown-v2>
                </div>
              </div>
              <div class="final-report-top-left-row" data-cy="finalreport-refergp-row">
                <div class="final-report-top-left-row-label" data-cy="finalreport-refergp-label">Refer To GP:</div>
                <div style="flex: 1;" class="final-report-dropdown" data-cy="finalreport-refergp-select">
                  <tdo-dropdown-v2 [datasource]="gpDoctors"
                                   [value]="getDoctor(nonGpDoctors, finalReportModel.RefereToGPDoctorID)"
                                   [displayPredicate]="doctorDisplayPredicate"
                                   (selectionChange)="$event.value ? referrToGPDoctorSelected($event) : log('undefined referrToGPDoctorSelected value', $event)"></tdo-dropdown-v2>
                </div>
              </div>
            </div>
            <div style="flex-basis: 8px; min-width: 8px;"></div>
            <div style="flex: 1; display: flex; flex-direction: column;" data-cy="finalreport-options">
              <!--              TOP RIGHT-->
              <mat-checkbox [ngModel]="!finalReportModel.isReportNeede" (change)="reportNeededChecked($event)" data-cy="finalreport-noreport-checkbox">No Report
                Needed
              </mat-checkbox>
              <input [value]="getDateFromModel(finalReportModel.CompletedDate)"
                     style="margin-top: 20px; border: unset; outline: unset; background-color: var(--tdo-background); border-radius: var(--border-radius);" data-cy="finalreport-completed-date">
              <div class="final-report-dropdown" data-cy="finalreport-casetype-select">
                <app-tdo-enum-select name="enumCaseType"
                                     [validValueItemId]="finalReportModel.enumCaseTypeID"
                                     (enumSelected)="finalReportModel.enumCaseTypeID = $event.ValidValueItemId; saveChanges()"
                                     (isUserInput)="setUserInput($event)"
                                     displayProperty="ItemDisplayValue"></app-tdo-enum-select>
              </div>
              <mat-checkbox [ngModel]="finalReportModel.isSuperRecall"
                            (change)="finalReportModel.isSuperRecall = $event.checked; this.isUserInput = true; saveChanges()"
                            style="margin-top: 5px;" data-cy="finalreport-super-checkbox">Super
              </mat-checkbox>
              <mat-checkbox [ngModel]="patientData.isDoNotEverTreatAgain"
                            (change)="patientData.isDoNotEverTreatAgain = $event.checked; this.isUserInput = true; savePatientDNETA()" data-cy="finalreport-dneta-checkbox">
                DNETA
              </mat-checkbox>
            </div>
          </div>
          <div class="final-report-left-cell" style="display: block;" data-cy="finalreport-recommendations-section">
            <span style="font-weight: 500;" data-cy="finalreport-recommendations-title">Restorative Recommendations</span><br/>
            <div style="margin-top: 10px; display: flex; flex-wrap: wrap; overflow-y: auto; height: 137px;" data-cy="finalreport-recommendations-list">
              <div *ngFor="let rec of restorationMethodEnums" style="min-width: 120px; margin-right: 6px;" data-cy="finalreport-recommendation-item">
                <mat-checkbox style="height: 20px;" [checked]="isRestorationChecked(rec)"
                              (change)="onRestorationChange($event, rec)" data-cy="finalreport-recommendation-checkbox">{{rec.ItemDisplayValue}}</mat-checkbox>
              </div>
            </div>
            <div style="display: flex; margin-top: 5px;" data-cy="finalreport-other-section">
              <mat-checkbox [checked]="isRestContainsOther()" (change)="onRestOtherChange($event)" data-cy="finalreport-other-checkbox">Other:</mat-checkbox>
              <div style="margin-left: 6px; flex: 1;">
<!--                <input (appInputFinished)="onOtherInputFinished($event)" [ngModel]="getOther()?.OtherInText"-->
<!--                       style="padding-left: 4px; padding-right: 4px; margin-right: 12px; width: 100%; outline: unset; border: unset; border-radius: var(&#45;&#45;border-radius); background-color: var(&#45;&#45;tdo-background);"/>-->
                <input (appInputFinished)="onOtherInputFinished($event)" [ngModel]="getOther()?.OtherInText"
                       style=" width: 100%; border-width: 1px ; border-radius: var(--border-radius); " data-cy="finalreport-other-input"/>

              </div>
              <button style="margin-left: 6px; position: relative; top: -6px;" (click)="onClearRest()"
                      class="tdo-button tdo-save" data-cy="finalreport-clear-recommendations-button">Clear
              </button>
            </div>
          </div>
          <div
            style="display: flex; flex-basis: 36px; max-height: 36px; background-color: white; border-radius: var(--border-radius); padding: 8px 4px 0 4px; margin-bottom: 8px;" data-cy="finalreport-treatment-section">
            <div style="flex: 1; display: flex; margin-right: 6px;" data-cy="finalreport-sessions-row">
              <span style="font-weight: 500;" data-cy="finalreport-sessions-label">Treatment sessions:</span>
              <div style="flex: 1; position: relative; top: -3px; margin-left: 3px;" class="final-report-dropdown" data-cy="finalreport-sessions-select">
                <app-tdo-enum-select name="enumTreatmentSessions"
                                     [validValueItemId]="finalReportModel.enumTreatmentSessionsID"
                                     (enumSelected)="finalReportModel.enumTreatmentSessionsID = $event.ValidValueItemId; saveChanges()"
                                     (isUserInput)="setUserInput($event)"
                                     displayProperty="ItemDisplayValue"
                ></app-tdo-enum-select>
              </div>
            </div>
            <div style="flex: 1; display: flex; margin-left: 6px; margin-right: 4px;" data-cy="finalreport-rating-row">
              <span style="font-weight: 500;" data-cy="finalreport-rating-label">Case rating:</span>
              <div style="flex: 1; position: relative; top: -3px; margin-left: 3px;" class="final-report-dropdown" data-cy="finalreport-rating-select">
                <app-tdo-enum-select name="enumCaseRating"
                                     [validValueItemId]="finalReportModel.enumCaseRatingID"
                                     (enumSelected)="finalReportModel.enumCaseRatingID = $event.ValidValueItemId; saveChanges()"
                                     (isUserInput)="setUserInput($event)"
                                     displayProperty="ItemDisplayValue"></app-tdo-enum-select>
              </div>
            </div>
          </div>
          <div
            style="flex-basis: 180px; background-color: white; border-radius: var(--border-radius); padding: 12px 4px 0 4px; margin-bottom: 6px; overflow-y: hidden;" data-cy="finalreport-referral-section">
            <span style="font-weight: 500" data-cy="finalreport-referral-title">Referral Reports</span>
            <div style="display: flex; flex-wrap: wrap; overflow-y: auto; height: 100px;" data-cy="finalreport-referral-list">
              <div *ngFor="let report of reports" style="min-width: 120px; margin-left: 6px;" data-cy="finalreport-referral-item">
                <mat-checkbox [checked]="isRefChecked(report)"
                              [disabled]="!finalReportModel.isReportNeede"
                              (change)="onReportsChange($event, report)" data-cy="finalreport-referral-checkbox">{{report.ReportName}}</mat-checkbox>
              </div>
            </div>
            <div style="display: flex;">
              <div style="flex: 1;"></div>
              <button class="tdo-button tdo-save" (click)="onClearReferralReports()" [disabled]="!finalReportModel.isReportNeede" data-cy="finalreport-clear-referrals-button">Clear</button>
            </div>
          </div>
          <div style="display: flex; flex-basis: 50px; background-color: white; border-radius: var(--border-radius); padding: 12px 4px 0 4px; margin-bottom: 6px; overflow-y: hidden;" data-cy="finalreport-diagnostics-section">
            <mat-checkbox style="margin-right: 12px;" [checked]="finalReportModel.isSendDiagnostics"
                          (change)="finalReportModel.isSendDiagnostics = $event.checked; this.isUserInput = true;  saveChanges()" data-cy="finalreport-diagnostics-checkbox">
              Diagnostic Report
            </mat-checkbox>
            <mat-radio-group [disabled]="!finalReportModel.isSendDiagnostics"
                             [value]="finalReportModel.isDiagnosticsLarge" aria-label="Select an option" data-cy="finalreport-diagnostics-size">
              <mat-radio-button style="margin-right: 6px;" [value]="false"
                                (change)="finalReportModel.isDiagnosticsLarge = false; this.isUserInput = true;  saveChanges()" data-cy="finalreport-diagnostics-small">
                Small
              </mat-radio-button>
              <mat-radio-button [value]="true"
                                (change)="finalReportModel.isDiagnosticsLarge = true; this.isUserInput = true; saveChanges()" data-cy="finalreport-diagnostics-large">
                Large
              </mat-radio-button>
            </mat-radio-group>
            <div style="flex: 1;"></div>
            <button style="position: relative; top: -6px;" class="tdo-button tdo-save" (click)="onOpenLetters()" data-cy="finalreport-mail-preset-button">Mail Preset
            </button>
          </div>
        </div>
        <div
          style="margin-left: 3px; flex-basis: 50%; border-radius: var(--border-radius); display: flex; flex-direction: column;" data-cy="finalreport-right-panel">
          <!--          RIGHT-->
          <div
            style="background-color: white; border-bottom: 6px; display: flex; flex-direction: column; padding: 6px; margin-bottom: 6px; border-radius: var(--border-radius);" data-cy="finalreport-notes-section">
            <div style="flex-basis: 420px; min-width: 440px; height: calc(80% ); margin-right: var(--margin-size); " data-cy="finalreport-notes-container">
              <div style="font-weight: 500;" data-cy="finalreport-notes-title">Final Notes for Referral Report</div>
              <div style="height: 95%; margin-bottom: var(--margin-size); overflow: hidden;" data-cy="finalreport-notes-editor">
                <app-tdo-simple-note height="100%" [numRows]="5" #simpleNote [categoryEnumId]="noteFind.categoryEnumId"
                    [typeEnumId]="noteFind.typeEnumId" [PatientId]="noteModel?.patientId"
                    [parentObjectName]="dataPatientCaseEndoFinalReport" [objectId]="finalReportModel?.CaseFinalReportID"></app-tdo-simple-note>
              </div>
            </div>
          </div>
          <div
            style="background-color: white; border-bottom: 6px; display: flex; flex-direction: column; padding: 6px; flex: 1; margin-bottom: 6px; border-radius: var(--border-radius);" data-cy="finalreport-status-section">
            <span style="font-weight: 500;" data-cy="finalreport-status-title">Referral Report Status</span>
            <div
              style="display: flex; flex-direction: column; overflow-y: auto; margin-top: 8px; flex: 1; padding: 8px;" data-cy="finalreport-status-list">
              <div *ngFor="let ref of finalReportModel.dataPatientCaseEndoFinalReportReferrReps"
                   style="display: flex; margin-bottom: 1px; overflow-x: scroll" data-cy="finalreport-status-item">
                <div style="flex: 1; display: flex;" data-cy="finalreport-status-to">
                  <span>To:</span>
                  <input [value]="SentToLabel" [disabled]="true" class="inputReport" data-cy="finalreport-status-to-value"/>
                </div>
                <div style="flex: 1; display: flex;" data-cy="finalreport-status-date">
                  <span>Date:</span>
                    <input [value]="ref.SentDate | date:'medium'" [disabled]="true" class="inputReport" data-cy="finalreport-status-date-value"/>
                </div>
                <div style="flex: 1; display: flex;" data-cy="finalreport-status-report">
                  <span>Report:</span>
                  <input [value]="getReportName(ref.ReportID)" [disabled]="true" class="inputReport" data-cy="finalreport-status-report-value"/>
                </div>

              </div>
            </div>
            <div style="display: flex;">
              <div style="flex: 1;"></div>
              <button (click)="sendFinalReport()" class="tdo-button tdo-save" style="margin-top: 8px;" data-cy="finalreport-submit-button">Submit/Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
